import { render, staticRenderFns } from "./TrSelectV2.vue?vue&type=template&id=535a81a6&scoped=true&"
import script from "./TrSelectV2.vue?vue&type=script&lang=js&"
export * from "./TrSelectV2.vue?vue&type=script&lang=js&"
import style0 from "./TrSelectV2.vue?vue&type=style&index=0&id=535a81a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a81a6",
  null
  
)

export default component.exports